<template>
    <el-container>
        <!-- 头部区域 -->
        <el-header>
            <div class="title">服务平台</div>
            <div class="back">
                <img src="../../images/u2705.svg" />
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">{{ adminName }}<i class="el-icon-arrow-down el-icon--right"
                            style="color: #000"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item><span @click="goBack">退出登录</span></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-dialog title="提示" :visible.sync="dialogVisibleBack" width="380px">
                <span><i class="el-icon-warning-outline" style="margin-right: 10px"></i>是否确认退出??</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisibleBack = false">取 消</el-button>
                    <el-button type="warning" @click="readGoBack">确 定</el-button>
                </span>
            </el-dialog>
        </el-header>
        <el-container>
            <!-- 侧边栏菜单 -->
            <el-aside width="240px">
                <el-menu background-color="#1a7cff" text-color="#fff" active-text-color="#fff" :unique-opened="true"
                    :router="true" :default-active="menu">
                    <el-menu-item index="/index" @click="saveMenu('/index')">
                        <i class="el-icon-s-home"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                    <el-menu-item index="/Invoice/UploadInvoice" @click="saveMenu('/Invoice/UploadInvoice')">
                        <i class="el-icon-plus"></i>
                        <span slot="title">票据上传</span>
                    </el-menu-item>
                    <!--<el-menu-item index="/Invoice/AnnualReport" @click="saveMenu('/Invoice/AnnualReport')">
                        <i class="el-icon-s-order"></i>
                        <span slot="title">年度报表</span>
                    </el-menu-item>-->
                    <el-submenu index="2">
                        <template slot="title">
                            <i class="el-icon-s-order"></i>
                            <span>我的票夹</span>
                        </template>
                        <el-menu-item index="/Invoice/OutpatientInvoiceDetails" @click="saveMenu('/Invoice/OutpatientInvoiceDetails')">门诊票据</el-menu-item>
                        <el-menu-item index="/Invoice/InpatientInvoiceDetails" @click="saveMenu('/Invoice/InpatientInvoiceDetails')">住院票据</el-menu-item>
                    </el-submenu>
                    <el-submenu index="3" v-if="isHrAudit || isFinAudit || isSuperuser || isStaff">
                        <template slot="title">
                            <i class="el-icon-s-order"></i>
                            <span>票据审批</span>
                        </template>
                        <el-menu-item index="/Invoice/OutpatientInvoiceCases" @click="saveMenu('/Invoice/OutpatientInvoiceCases')">门诊票据审批</el-menu-item>
                        <el-menu-item index="/Invoice/InpatientInvoiceCases" @click="saveMenu('/Invoice/InpatientInvoiceCases')">住院票据审批</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4" v-if="isHrAudit || isFinAudit || isSuperuser || isStaff">
                        <template slot="title">
                            <i class="el-icon-s-order"></i>
                            <span>数据总览</span>
                        </template>
                        <el-menu-item index="/Invoice/OutpatientInvoiceOverview" @click="saveMenu('/Invoice/OutpatientInvoiceOverview')">门诊票据详情</el-menu-item>
                        <el-menu-item index="/Invoice/InpatientInvoiceOverview" @click="saveMenu('/Invoice/InpatientInvoiceOverview')">住院票据详情</el-menu-item>
                        <el-menu-item index="/Invoice/OutpatientCasesOverview" @click="saveMenu('/Invoice/OutpatientCasesOverview')">门诊CASE详情</el-menu-item>
                        <el-menu-item index="/Invoice/InpatientCasesOverview" @click="saveMenu('/Invoice/InpatientCasesOverview')">住院CASE详情</el-menu-item>
                        <el-menu-item index="/Invoice/AnnualReportOverview" @click="saveMenu('/Invoice/AnnualreportOverview')">年度报表总览</el-menu-item>
                    </el-submenu>

                    <!--<el-menu-item index="/message" @click="saveMenu('/message')">
                        <i class="el-icon-chat-round"></i>
                        <span slot="title">我的消息</span>
                    </el-menu-item>
                    <el-menu-item index="/sysnotice" @click="saveMenu('/sysnotice')">
                        <i class="el-icon-collection"></i>
                        <span slot="title">系统公告</span>
                    </el-menu-item>
                    <el-menu-item index="/makeReview" @click="saveMenu('/makeReview')" v-if="isSuperuser">
                        <i class="el-icon-s-check"></i>
                        <span slot="title">票据审批</span>
                    </el-menu-item>

                    <el-submenu index="2">
                        <template slot="title">
                            <i class="el-icon-s-check"></i>
                            <span>预约管理</span>
                        </template>
                        <el-menu-item index="/Scheduling" @click="saveMenu('/Scheduling')">仪器排班</el-menu-item>
                        <el-menu-item index="/doctorMakeList" @click="saveMenu('/doctorMakeList')">医生名下</el-menu-item>
                    </el-submenu>

                    <el-menu-item index="/makeList" @click="saveMenu('/makeList')">
                        <i class="el-icon-phone"></i>
                        <span slot="title">我的票夹</span>
                    </el-menu-item>
                    <el-submenu index="3">
                        <template slot="title">
                            <i class="el-icon-s-order"></i>
                            <span>费用管理</span>
                        </template>
                        <el-menu-item index="/order/recorder" @click="saveMenu('/order/recorder')">充值订单</el-menu-item>
                        <el-menu-item index="/order/payOrder" @click="saveMenu('/order/payOrder')">其他缴费</el-menu-item>
                        <el-menu-item index="/order/refund" @click="saveMenu('/order/refund')">退款管理</el-menu-item>
                    </el-submenu>
                    <el-submenu index="4" v-if="isSuperuser">
                        <template slot="title">
                            <i class="el-icon-s-order"></i>
                            <span>基本信息</span>
                        </template>
                        <el-menu-item index="/dep/hospital" @click="saveMenu('/dep/hospital')">校区管理</el-menu-item>
                        <el-menu-item index="/dep/depOne" @click="saveMenu('/dep/depOne')">一级科室</el-menu-item>
                        <el-menu-item index="/dep/depTwo" @click="saveMenu('/dep/depTwo')">二级科室</el-menu-item>
                        <el-menu-item index="/dep/doctor" @click="saveMenu('/dep/doctor')">仪器管理</el-menu-item>
                    </el-submenu>-->
                    <el-submenu index="7" v-if="isSuperuser || isStaff">
                        <template slot="title">
                            <i class="el-icon-s-platform"></i>
                            <span>系统信息</span>
                        </template>
                        <el-menu-item index="/systemInfo/swiper" @click="saveMenu('/systemInfo/swiper')">轮播图设置
                        </el-menu-item>
                        <!--<el-menu-item index="/systemInfo/navigation" @click="saveMenu('/systemInfo/navigation')">医院导航
                        </el-menu-item>-->
                        <el-menu-item index="/systemInfo/notice" @click="saveMenu('/systemInfo/notice')">公告发布
                        </el-menu-item>
                        <!--<el-menu-item index="/systemInfo/encyclopedias" @click="saveMenu('/systemInfo/encyclopedias')">
                            健康百科
                        </el-menu-item>
                        <el-menu-item index="/systemInfo/share" @click="saveMenu('/systemInfo/share')">
                            文章分享</el-menu-item>
                        <el-menu-item index="/systemInfo/addDrticle" @click="saveMenu('/systemInfo/addDrticle')">
                            发布文章</el-menu-item>
                        <el-menu-item index="/systemInfo/feedback" @click="saveMenu('/systemInfo/feedback')">用户反馈
                        </el-menu-item>-->
                    </el-submenu>
                    <el-submenu index="6" v-if="isHrAudit || isSuperuser || isStaff">
                        <template slot="title">
                            <i class="el-icon-user-solid"></i>
                            <span>权限管理</span>
                        </template>
                        <el-menu-item index="/users/userlist" @click="saveMenu('/users/userlist')">用户管理</el-menu-item>
                        <el-menu-item index="/users/approvalsrelations" @click="saveMenu('/users/approvalsrelations')">审批管理</el-menu-item>
                        <!--<el-menu-item index="/users/depList" @click="saveMenu('/users/depList')">就诊人管理</el-menu-item>
                        <el-menu-item index="/users/Message" @click="saveMenu('/users/Message')">消息管理</el-menu-item>-->
                    </el-submenu>
                    <!--<el-submenu index="7"v-if="isSuperuser">
                        <template slot="title">
                            <i class="el-icon-s-tools"></i>
                            <span>系统设置</span>
                        </template>
                        <el-menu-item index="/set/addAdmin" @click="saveMenu('/set/addAdmin')">添加管理员</el-menu-item>
                        <el-menu-item index="/set/setPass" @click="saveMenu('/set/setPass')">信息修改</el-menu-item>
                    </el-submenu>-->
                </el-menu>
            </el-aside>
            <!-- main区域 -->
            <el-main>
                <router-view></router-view>
            </el-main>
        </el-container>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            adminName: '',
            dialogVisibleBack: false,
            menu: '',
            isSuperuser: false, // 添加管理员状态
            isHrAudit: false,
            isFinAudit: false
        }
    },
    mounted() {
        this.adminName = localStorage.getItem('adminName')
        console.log('this.adminName', this.adminName)
        this.isSuperuser = localStorage.getItem('isSuperuser') === 'true' // 从本地存储获取管理员状态
        console.log('isSuperuser:', this.isSuperuser)
        this.isHrAudit = localStorage.getItem('isHrAudit') === 'true'
        console.log('isHrAudit:', this.isHrAudit)
        this.isFinAudit = localStorage.getItem('isFinAudit') === 'true'
        console.log('isFinAudit:', this.isFinAudit)
    },
    created() {
        this.menu = localStorage.getItem('menu')
    },
    methods: {
        goBack() {
            this.dialogVisibleBack = true
            console.log('this.dialogVisibleBack', this.dialogVisibleBack)
        },
        /**
         * Handles user logout by clearing local storage and redirecting to login page
         * - Closes the back dialog
         * - Removes admin name, token time and menu from localStorage
         * - Redirects user to login page
         */
        readGoBack() {
            this.dialogVisibleBack = false
            localStorage.setItem('adminName', '')
            localStorage.setItem('tokenStartTime', '')
            localStorage.setItem('menu', '')
            localStorage.setItem('isSuperuser', '')
            localStorage.setItem('isHrAudit', '') // 清除管理员状态
            this.$router.push('/login')
        },
        saveMenu(menu) {
            localStorage.setItem('menu', menu)
            this.menu = menu
        },
    },
}
</script>

<style lang="less" scoped>
/deep/.el-icon-arrow-down:before {
    color: #fff !important;
}

.el-header {
    background-color: #ffffff;
    color: #333;
    text-align: center;
    //   line-height: 60px;
    display: flex;
    padding: 0;
    margin: 0;
    justify-content: space-between;
    padding-right: 30px;
    box-sizing: border-box;
    box-shadow: 0px 5px 5px rgb(215 215 215 / 35%) !important;

    .title {
        font-size: 23px;
        color: #fff;
        background: #1a7cff;
        width: 240px;
        height: 60px;
        line-height: 60px;
    }

    .back {
        display: flex;
        align-items: center;
        padding-right: 15px;

        img {
            width: 40px;
            height: 40px;
            border-radius: 100%;
            background: #1a7cff;
            border: 1px solid #ccc;
            padding: 5px;
            box-sizing: border-box;
            margin-right: 10px;
        }

        .el-dropdown-link {
            //设置鼠标样式为手指
            cursor: pointer;
        }

        .el-icon-arrow-down:before {
            color: #000 !important;
            font-size: 16px;
        }
    }
}

.el-aside {
    background-color: #1a7cff;
    color: #333;
    //   text-align: center;
    line-height: 200px;

    .el-menu {
        border: 1px solid rgb(26, 124, 255);
        margin-top: 20px;

        .el-submenu .el-menu-item {
            padding-left: 70px !important;
        }

        i:before {
            color: #fff;
        }

        .el-icon-arrow-down:before {
            color: #fff;
            font-size: 16px;
        }
    }

    .el-menu-item:hover {
        background: #006eff !important;
    }

    .el-menu-item.is-active {
        background: #006eff !important;
    }

    .el-submenu__title:focus,
    .el-submenu__title:hover {
        background: #006eff !important;
    }

    .el-submenu /deep/ .el-submenu__title:hover {
        background: #006eff !important;
    }
}

.el-main {
    background-color: #f3f8ff;
    color: #333;
    text-align: center;
    margin-top: 5px;
    margin-right: 20px;
    margin-left: 20px;
}

body>.el-container {
    margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
    line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
    line-height: 320px;
}

.el-container {
    height: 100%;
    overflow: auto;
}
</style>